import { render, staticRenderFns } from "./shetubaogao.vue?vue&type=template&id=e13360c2&"
import script from "./shetubaogao.vue?vue&type=script&lang=ts&"
export * from "./shetubaogao.vue?vue&type=script&lang=ts&"
import style0 from "./shetubaogao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports